import { queryOptions } from '@tanstack/react-query';
import { deliveryReportApi } from './delivery-report-api';

/** Query-key factory for the delivery-reports slice. */
export const deliveryReportKeys = {
  all: ['delivery-reports'] as const,
  summary: () => [...deliveryReportKeys.all, 'summary'] as const,
};

export const deliveryReportQueries = {
  summary: () =>
    queryOptions({
      queryKey: deliveryReportKeys.summary(),
      queryFn: () => deliveryReportApi.get(),
    }),
};
